// Whether a nav entry's route is the one being viewed. A substring test was doing this before, which
// made /addintegrations match an entry for /integrations — "addintegrations" contains it — so two
// entries highlighted at once. Only a whole segment counts.
export const isActivePath = (pathname, url) => {
    if (!url || url === "/") {
        return false;
    }

    const path = (pathname || "").toLowerCase().replace(/\/+$/, "");
    const route = url.toLowerCase().replace(/\/+$/, "");

    return path === route || path.startsWith(`${route}/`);
};

export default isActivePath;
